// ABOUTME: The class spark-ui's own reset leaves an escape hatch for, named once so every frame that
// ABOUTME: stands in for the chrome reaches for the same string.

export const SPARK_ISOLATE_CLASS = "spark-isolate";
